import React from 'react'
import cx from 'classnames'
import RA from 'ra-config'
import { coreSiteUrl, interactiveSiteUrl } from 'lib/config/url'
import Icon from 'lib/components/icon'

const { globalNavigation } = RA.app.page

class Header extends React.PureComponent {
  static defaultProps = {
    className: '',
    logoWidth: '151px',
    logoHeight: '60px',
    naxAuxContent: null
  }

  focusTimer = null

  state = {
    isActive: false
  }

  open = () => {
    this.setState({ isActive: true })
  }

  close = () => {
    this.setState({ isActive: false })
  }

  toggle = () => {
    this.state.isActive ? this.close() : this.open()
  }

  autoHide = event => {
    if (this.refs.dropdown.contains(event.target)) {
      return null
    }

    this.close()
  }

  closeOnEscape = event => {
    if (event.key === 'Escape') {
      this.close()
      this.refs.toggle.focus()
    }
  }

  componentDidMount() {
    document.body.addEventListener('click', this.autoHide, true)
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.autoHide, true)
  }

  renderMenuItem({ text, path, site }) {
    let href =
      site === 'interactive' ? interactiveSiteUrl(path) : coreSiteUrl(path)

    return (
      <a key={href} href={href}>
        {text}
      </a>
    )
  }

  renderAuxContent() {
    const { navAuxContent } = this.props

    return navAuxContent ? (
      <div className="split-nav__aux">{React.createElement(navAuxContent)}</div>
    ) : null
  }

  render() {
    const { className } = this.props
    const { isActive } = this.state

    const headerClasses = cx('header split-nav', className)

    const dropdownClassname = cx('header__dropdown', {
      '-active': isActive
    })

    const menuButtonType = isActive ? 'x' : 'hamburger'

    return (
      <header className={headerClasses}>
        <div
          className={dropdownClassname}
          ref="dropdown"
          onKeyDown={this.closeOnEscape}
        >
          <div
            className="header__dropdown__menu"
            tabIndex={this.isActive ? 0 : -1}
          >
            {globalNavigation.map(this.renderMenuItem, this)}
          </div>
        </div>
        <div className="split-nav__left">
          <div className="header__menu-button" ref="dropdown">
            <button
              ref="toggle"
              aria-controls="header-menu"
              onClick={this.toggle}
            >
              <Icon
                type={menuButtonType}
                height="16px"
                width="16px"
                className="block-icon"
              />
              <span className="screenreader-only">Toggle Menu</span>
            </button>
          </div>
        </div>

        <div className="split-nav__main">
          <a href="#!/strategies">
            <img
              src={this.props.logoUrl}
              width={this.props.logoWidth}
              height={this.props.logoHeight}
              alt="Logo"
            />
          </a>
        </div>

        {this.renderAuxContent()}
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/header/index.js